import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({providedIn:'root'})
export class ProfilePictureService {
    private picture = new Subject<string>();
    changeEvent = this.picture.asObservable();
    constructor() {
    }

    changePicture() {
        this.picture.next();
    }
}